let CLIENTS = {};
let STANDARD_HOOKS = {};
const setApiClients = clients => CLIENTS = clients;
const setStandardHooks = standardHooks => STANDARD_HOOKS = standardHooks;
export { CLIENTS, STANDARD_HOOKS, setApiClients, setStandardHooks };
//# sourceMappingURL=config.js.map